// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"60396b27","338":"dea35326","474":"9ac71a20","952":"f449977b"}[chunkId] + ".chunk.css";
};